import { Button, DialogTitle, DialogContent, DialogActions, Stack, TextField, IconButton } from "@mui/material";
import { sendEmail } from "../../redux/admin-slices/specialist.slice";
import { hideDialog } from "../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../assets/js/Icons";
import { useState } from "react";

const SendMail = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.otherSlice) || {};

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleClose = () => {
    dispatch(hideDialog());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      sendEmail({
        email: data?.email,
        username: data?.username,
        subject,
        message,
      })
    );
    handleClose();
  };
  return (
    <form onSubmit={handleSubmit}>
      <DialogTitle>
        Send Message
        <IconButton onClick={handleClose} style={{ float: "right" }}>
          <Icons.CancelSolid />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            label="Email"
            value={data?.email || ""}
            fullWidth
            disabled
          />
          <TextField
            label="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            fullWidth
          />
          <TextField
            label="Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            fullWidth
            multiline
            rows={4}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" type="submit">
          Send Message
        </Button>
      </DialogActions>
    </form>
  );
};

export default SendMail;